import {Component, OnDestroy, OnInit} from '@angular/core';
import { Subscription } from 'rxjs';
import { Images } from '@constants/images';
import { LoaderFacade } from '@redux/facades/loader.facade';
import { MyLoadable } from '@models/my-loadable';

@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnDestroy, OnInit {
  public images = Images;
  public className = '';
  public animation = 'show';
  public loader: MyLoadable = { loading: false, success: false, error: '', okMessage: '' };
  // @ts-ignore
  public unsubscribeLoader: Subscription;

  constructor(
    public loaderFacade: LoaderFacade,
  ) {
    const self = this;
    self.unsubscribeLoader = self.loaderFacade.loaderState$.subscribe(
      ok => {
        self.loader = ok;
        if (ok.loading) {
          self.animation = 'show';
        }
      }
    );
  }

  ngOnInit(): any {
    const self = this;
    self.loader = { loading: false, success: false, error: '', okMessage: '' };
  }

  // tslint:disable-next-line:typedef
  ngOnDestroy() {
    const self = this;
    self.unsubscribeLoader.unsubscribe();
  }

  closeNotification = () => {
    /* setTimeout( () => {
      this.animation = 'close';
    }, 3500);
    setTimeout( () => {
      this.notificationFacade.closeNotification();
    }, 4000); */
  }
}
